import { gql } from 'apollo-boost';
import { removeTypename, removeId } from './util';

export const SEARCH_PROGRAMS = gql`
  query($page: Int = 1, $limit: Int = 30, $search: ProgramSearch) {
    programs(page: $page, limit: $limit, search: $search) {
      total
      page
      pages
      docs {
        id
        name
        events {
          id
          date
        }
      }
    }
  }
`;

export const PROGRAMS_PLAN = gql`
  query(
    $page: Int = 1
    $limit: Int = 100
    $search: ProgramSearch
    $eventSearch: EventSearchInput
  ) {
    programs(page: $page, limit: $limit, search: $search) {
      total
      page
      pages
      docs {
        id
        name
        constraints {
          staff
          capacity
        }
        organization
        coordinator {
          id
          firstName
          lastName
        }
        events(search: $eventSearch) {
          id
          date
          published
          leader {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`;

export const PROGRAM = gql`
  query($id: ID) {
    program(id: $id) {
      id
      name
      description
      isOnGoing
      shortDescription
      organization
      addressLineOne
      addressLineTwo
      city
      state
      postal
      location {
        id
      }
      coordinator {
        id
      }
      category {
        id
      }
      secondaryCategory {
        id
      }

      contacts {
        name
        email
        phone
      }

      sponsors {
        id
      }

      communications {
        id
        name
        timing
        subject
        type
        program
        body
      }

      partnerQuote
      takeNote
      notes
      headerImage
      cardImage

      annualSchedule
      monthlyBudget

      constraints {
        capacity
        minAge
        staff
      }
    }
  }
`;

export const PROGRAM_COMMUNICATIONS = gql`
  query($program: ID) {
    communications(program: $program) {
      id
      name
      timing
      subject
      type
      program
      body
    }
  }
`;

export const ADD_PROGRAM = gql`
  mutation($input: ProgramInput) {
    addProgram(input: $input) {
      id
    }
  }
`;

export const UPDATE_PROGRAM = gql`
  mutation($input: ProgramInput) {
    updateProgram(input: $input) {
      id
    }
  }
`;

export function programDefaultValue(value) {
  return {
    name: '',
    category: { id: '' },
    secondaryCategory: { id: '' },
    description: '',
    shortDescription: '',
    isOnGoing: false,
    takeNote: '',
    partnerQuote: '',
    headerImage: '',
    cardImage: '',
    sponsors: [],
    annualSchedule: [],
    contacts: [],
    coordinator: { id: '' },
    notes: '',
    monthlyBudget: null,
    communications: [
      { type: 'Tips', date: null },
      { type: 'Reminder', date: null },
      { type: 'ThankYou', date: null },
    ],
    constraints: {
      minAge: null,
      staff: null,
      capacity: null,
    },
  };
}

export function programValueToInput(value) {
  return {
    name: value.name,
    coordinator: value.coordinator.id,
    category: value.category.id,
    secondaryCategory: value.secondaryCategory.id,
    annualSchedule: value.annualSchedule,
    description: value.description,
    isOnGoing: value.isOnGoing === true ? true : false,
    shortDescription: value.shortDescription,
    sponsors: value.sponsors.map((s) => {
      return s.id;
    }),
    organization: value.organization,
    addressLineOne: value.addressLineOne,
    addressLineTwo: value.addressLineTwo,
    city: value.city,
    state: value.state,
    postal: value.postal,
    communications: (value.communications || [])
      .map(removeTypename)
      .map(removeId),
    contacts: value.contacts.map(removeTypename),
    constraints: removeTypename(value.constraints),
    partnerQuote: value.partnerQuote,
    headerImage: value.headerImage,
    cardImage: value.cardImage,
    monthlyBudget: value.monthlyBudget,
    notes: value.notes,
    takeNote: value.takeNote,
  };
}
